const verbose = process.env.REACT_APP_VERBOSE === 'true' ;

export default verbose ;
